import { MdKeyboardArrowLeft } from 'react-icons/md';
import { useHistory } from 'react-router-dom';
import styles from './VoltarLink.module.scss';

export const VoltarLink = () => {
  const history = useHistory();

  const handleClick = () => {
    history.push('/isa/central-de-monitoramento');
  };

  return (
    <div className={styles.container}>
      <button type="button" className={styles.link} onClick={handleClick}>
        <MdKeyboardArrowLeft size={16} className={styles.icon} />
        <span className={styles.text}>Voltar para Central de Monitoramento Infopanel</span>
      </button>
    </div>
  );
};
